import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { LoadInitialStateAction } from '../first-steps.actions';

@Component({
  selector: 'cc-first-steps-root',
  templateUrl: './first-steps-root.component.html',
  styleUrls: ['./first-steps-root.component.scss']
})
export class FirstStepsRootComponent implements OnInit {
  constructor(private store: Store<IState>) {}

  ngOnInit() {
    this.store.dispatch(new LoadInitialStateAction());
  }
}
